import { RootState } from '../../Presentation/store';
import { Slot, PaginationInfo, AppliedFilters } from '../Model/Slot';

export const selectSlots        = (s: RootState) => Array.isArray(s.slot.list) ? s.slot.list : [];
export const selectSlotLoading  = (s: RootState) => s.slot.loading;
export const selectSlotError    = (s: RootState) => s.slot.error;
export const selectSlotPagination = (s: RootState) => s.slot.pagination;
export const selectSlotFilters = (s: RootState) => s.slot.filters;
export const selectSlotNeedsRefresh = (s: RootState) => s.slot.needsRefresh;

export const makeSelectSlotById = (id: number) => (state: RootState): Slot | undefined =>
  state.slot.list.find(s => s.slotId === id);

// 페이지네이션 관련 헬퍼 selector들
export const selectCurrentPage = (s: RootState) => s.slot.pagination?.current_page || 1;
export const selectPageSize = (s: RootState) => s.slot.pagination?.page_size || 20;
export const selectTotalCount = (s: RootState) => s.slot.pagination?.total_count || 0;
export const selectTotalPages = (s: RootState) => s.slot.pagination?.total_pages || 0;
export const selectHasNext = (s: RootState) => s.slot.pagination?.has_next || false;
export const selectHasPrevious = (s: RootState) => s.slot.pagination?.has_previous || false;

// 기본 페이지 캐시 관련 selector들
export const selectDefaultPageSlots = (s: RootState) =>
  Array.isArray(s.slot.defaultPage.slots) ? s.slot.defaultPage.slots : [];
export const selectDefaultPagePagination = (s: RootState) => s.slot.defaultPage.pagination;
export const selectDefaultPageLoaded = (s: RootState) => s.slot.defaultPage.loaded;
